import { DynamicStandaloneImage } from '@/components/Image';
import { LabradorComponent } from '@/types/component';
import { withDebugMetadata } from 'lib/utils';
import { mapLabradorImageToStandaloneImage } from 'lib/utils/image';

const LabradorImage: LabradorComponent = ({ type, data, meta, descendants }) => {
  const parent = meta.path.split('/').pop() || '';

  // Caption should never be shown on article teasers
  if (parent === 'articleTeaser') data.showCaption = false;

  return (
    <DynamicStandaloneImage
      {...mapLabradorImageToStandaloneImage({ type, data, meta, children: descendants })}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default LabradorImage;
